import './Sales.scss';

import { SvgIcon } from '@mui/material';
import ButtonField from '../../Components/Button/ButtonField';
import Table from '../../Components/Table/Table';
import CustomToolbar from '../../Components/Table/components/CustomToolbar';
import TableSearch from '../../Components/Table/components/TableSearch';
import { ISalesList, SalessProps } from './ISales';
import {
  FunctionComponent,
  MouseEvent,
  SetStateAction,
  useEffect,
  useState,
} from 'react';
import { ReactComponent as Add } from '../../Assets/Images/Add.svg';
import { Columns } from '../../Components/Table/ITable';
import { useAppDispatch, useAppSelector } from '../../Redux/Store/Hooks';
import { getSales } from '../../Redux/Slicers/Sales/SalesSlicer';
import {
  GridActionsCellItem,
  GridRowParams,
  GridValueGetterParams,
} from '@mui/x-data-grid';
import { ReactComponent as Edit } from '../../Assets/Images/Edit.svg';
import { ReactComponent as Delete } from '../../Assets/Images/Delete.svg';
import Dialog from '../../Components/Dialog/Dialog';
import IconButtonField from '../../Components/Button/IconButtonField';
import { ReactComponent as Cancel } from '../../Assets/Images/Cancel.svg';
// import SalesForm from './SalesForm';
import { FormikProps } from 'formik';
// import {
//   clearUpdateSalesState,
//   salessUpdateableData,
// } from '../../Redux/Slicers/Sales/UpdateSalesSlicer';
import ResponseDialog from '../../Components/ResponseDialog/ResponseDialog';
import DeleteDialog from '../../Components/DeleteDialog/DeleteDialog';
// import {
//   clearDeleteSales,
//   deleteSales,
// } from '../../Redux/Slicers/Sales/DeleteSalesSlice';
// import { clearAddSalesState } from '../../Redux/Slicers/Sales/AddSalesSlicer';
import moment from "moment";

const Sales: FunctionComponent<SalessProps> = () => {
  const dispatch = useAppDispatch();
  const { data } = useAppSelector((state) => state.Sales);
  const [open, setOpen] = useState<boolean>(false);
  const [deleteOpen, setDeleteOpen] = useState<boolean>(false);
  const [deleteableName, setDeleteableName] = useState<string>("");
  const [deleteableId, setDeleteableId] = useState<number>(0);
  const [formik, setFormik] = useState<FormikProps<ISalesList>>();

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);
   const [sortField, setSortField] = useState("created_at");
   const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc");
   // const { data: updateSales, updateableDate } = useAppSelector(
   //   (state) => state.UpdateSales
   // );
   // const { data: addSales } = useAppSelector((state) => state.AddSales);
   // const { data: deleteSalesData } = useAppSelector(
   //   (state) => state.DeleteSales
   // );

   // const isUpdateable =
   //   updateableDate && Object.keys(updateableDate).length !== 0;
   const column: Columns = [
     {
       field: "index",
       renderHeader: () => <b>S.No</b>,
       flex: 1,
       headerAlign: "center",
       align: "center",
       type: "number",
       maxWidth: 90,
       sortable: false,
     },
     {
       field: "first_name",
       renderHeader: () => <b>Owner</b>,
       flex: 1,
       type: "string",
       maxWidth: 130,
       sortable: false,
     },
     {
       field: "vehicle_plate_no",
       renderHeader: () => <b>Vehicle No</b>,
       flex: 1,
       type: "string",
       maxWidth: 130,
       sortable: false,
     },
     {
       field: "location_name",
       renderHeader: () => <b>Location</b>,
       flex: 1,
       type: "string",
       sortable: false,
     },
     {
       field: "check_in",
       renderHeader: () => <b>Enter</b>,
       flex: 1,
       type: "string",
     },
     {
       field: "check_out",
       renderHeader: () => <b>Exit</b>,
       flex: 1,
       type: "string",
     },
     {
       field: "duration",
       renderHeader: () => <b>Duration(Minutes)</b>,
       flex: 1,
       type: "string",
     },
     {
       field: "Amount",
       renderHeader: () => <b>Amount Paid</b>,
       flex: 1,
       type: "string",
       maxWidth: 130,

       // valueGetter: (params: GridValueGetterParams<ISalesList>) =>
       //   params.row.role?.role_name,
     },
     // {
     //   field: 'status',
     //   renderHeader: () => <b>Status</b>,
     //   flex: 1,
     //   type: 'boolean',
     //   maxWidth: 190,

     //   renderCell: (params) => (
     //     <div>{params.value ? 'Active' : 'In-active'}</div>
     //   ),
     //   cellClassName: (params) => (params.value ? 'active' : 'inactive'),
     // },
     // {
     //   field: 'action',
     //   renderHeader: () => <b>Action</b>,
     //   flex: 1,
     //   type: 'actions',
     //   getActions: (params: GridRowParams<any>) => [
     //     <GridActionsCellItem
     //       key="Edit"
     //       label="Edit"
     //       icon={<Edit className="action_icons" />}
     //       onClick={() => {
     //         dispatch(salessUpdateableData(params.row));
     //         setOpen(true);
     //       }}
     //     />,
     //     <GridActionsCellItem
     //       key="Delete"
     //       label="Delete"
     //       icon={<Delete className="action_icons" />}
     //       onClick={() => {
     //         setDeleteOpen(true);
     //         setDeleteableName(params.row.name ?? '');
     //         setDeleteableId(params.row.id!);
     //       }}
     //     />,
     //   ],
     //   cellClassName: 'action_cell',
     // },
   ];

   // useEffect(() => {
   //   // console.log('renderd');

   //   dispatch(getSales({ page, pageSize })); // 🔑 pass to backend
   // }, []);

   // useEffect(() => {
   //   return () => {
   //     dispatch(clearAddSalesState());
   //     dispatch(clearUpdateSalesState());
   //     dispatch(clearDeleteSales());
   //   };
   // }, []);

   const data1 = data?.response?.data;
   console.log(data1);
   const formatDateTimeUTC = (date: any) =>
     date ? moment.utc(date).format("YYYY-MM-DD - HH:mm") : "N/A";

   const salesData = Array.isArray(data1)
     ? data1.map((sales, index) => ({
         ...sales,
         id: sales?._id,
         index: page * pageSize + (index + 1), // ✅ fixed serial number
         vehicle_plate_no: sales?.vehicle_id?.vehicle_plate_no,
         location_name: sales?.location_id?.location_name,
         first_name: sales?.owner_id?.first_name,
         check_in: sales?.check_in ? formatDateTimeUTC(sales?.check_in) : "N/A",
         check_out: sales?.check_out
           ? formatDateTimeUTC(sales?.check_out)
           : "N/A",
       }))
     : [];

   const salesForm = (data: FormikProps<ISalesList>) => {
     setFormik(data);
   };

   useEffect(() => {
     dispatch(getSales({ page, pageSize, sortField, sortOrder })); // 🔑 pass to backend
   }, [page, pageSize, dispatch, sortField, sortOrder]);

   return (
     <>
       <Table
         rows={salesData ?? []}
         columns={column}
         rowCount={(data?.response as any)?.total ?? 0}
         onPageChange={(newPage, newPageSize) => {
           setPage(newPage);
           setPageSize(newPageSize);
         }}
         onSortChange={(field, order) => {
           if (field && order) {
             setSortField(field);
             setSortOrder(order);
           }
         }}>
         <CustomToolbar>
           <h6>Sales</h6>
           <TableSearch />
           {/* <ButtonField
            className="add_button"
            onClick={() => setOpen(true)}>
            <SvgIcon
              component={Add}
              inheritViewBox
            />
            Add New
          </ButtonField> */}
         </CustomToolbar>
       </Table>

       {/* <Dialog
        open={open}
        dialogClassName="sales_dialog"
        dialogTitleClassName="sales_dialog_title"
        Dialog_Title={
          <>
            {isUpdateable ? 'Edit' : 'Add New User'}
            <IconButtonField onClick={() => setOpen(false)}>
              <SvgIcon
                component={Cancel}
                inheritViewBox
              />
            </IconButtonField>
          </>
        }
        Dialog_Content={<SalesForm salesForm={salesForm} />}
        dialogActionClassName="sales_dialog_action"
        Dialog_Actions={
          <>
            <ButtonField
              className="cancel_button"
              onClick={() => setOpen(false)}>
              Cancel
            </ButtonField>
            <ButtonField
              className="add_button"
              onClick={() => formik?.handleSubmit()}>
              {isUpdateable ? 'Update' : 'Save'}
            </ButtonField>
          </>
        }
      />

      <ResponseDialog
        response={addSales}
        parentDialog={setOpen}
      />
      <ResponseDialog
        response={updateSales}
        parentDialog={setOpen}
      /> */}

       {/* <DeleteDialog
        deleteableName={deleteableName}
        open={deleteOpen}
        setOpen={setDeleteOpen}
        deleteFunction={() => dispatch(deleteSales(deleteableId))}
        response={deleteSalesData}
      /> */}
     </>
   );
};

export default Sales;
